/**
 * TGTP Product Referrer Restriction
 *
 * 商品の `referral_tag_*` product tag を見て、ユーザの localStorage tag と
 * 突き合わせ、購入可否を client-side で判定する。OR 条件:
 *   - 商品に referral_tag_a / referral_tag_b があり、
 *   - ユーザが localStorage に referral_tag_a を持っていれば購入可。
 *
 * 期待する DOM:
 *   <div class="tgtp-product-buy-button"
 *        data-button-state="available"
 *        data-required-referral-tags="referral_tag_a,referral_tag_b,"
 *        data-referrer-restricted-label="対象メンバー限定商品です">
 *     <button class="tgtp-product-buy-btn" data-original-label="カートに入れる">
 *       <span class="tgtp-product-buy-btn__text">カートに入れる</span>
 *     </button>
 *   </div>
 *
 * - data-button-state !== "available" の時は何もしない（Liquid 側 state を尊重）。
 * - 必要タグが空 (data-required-referral-tags が無い) なら何もしない。
 * - 必要タグあり & 持っていない → disabled + ラベル切替 + dataset.referrerBlocked=true
 * - section-refreshed イベントで再 init（buy-button が差し替えられた時）。
 */
(() => {
  const SECTION_SELECTOR = ".tgtp-main-product";
  const WRAPPER_SELECTOR = ".tgtp-product-buy-button";
  const BUTTON_SELECTOR = ".tgtp-product-buy-btn";
  const LABEL_SELECTOR = ".tgtp-product-buy-btn__text";

  const parseRequiredTags = (raw) => {
    if (!raw) return [];
    return raw
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);
  };

  const hasAnyTag = (required) => {
    if (typeof window.tgtpHasReferrerTag !== "function") return false;
    return required.some((tag) => window.tgtpHasReferrerTag(tag));
  };

  const attach = (section) => {
    const wrapper = section.querySelector(WRAPPER_SELECTOR);
    if (!wrapper) return;
    if (wrapper.dataset.buttonState !== "available") return;

    const required = parseRequiredTags(wrapper.dataset.requiredReferralTags);
    if (required.length === 0) return;

    const btn = wrapper.querySelector(BUTTON_SELECTOR);
    if (!btn) return;

    const labelEl = btn.querySelector(LABEL_SELECTOR) ?? btn;
    const blockedLabel =
      wrapper.dataset.referrerRestrictedLabel || "対象メンバー限定商品です";
    const originalLabel = btn.dataset.originalLabel ?? labelEl.textContent;

    if (hasAnyTag(required)) {
      // 持っている → 何もしない（Liquid の state そのまま）
      delete wrapper.dataset.referrerBlocked;
      return;
    }

    // 持っていない → block
    btn.disabled = true;
    labelEl.textContent = blockedLabel;
    wrapper.dataset.referrerBlocked = "true";
  };

  const init = () => {
    const section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;

    if (!section.dataset.tgtpReferrerRestrictionInitialized) {
      section.dataset.tgtpReferrerRestrictionInitialized = "1";
      section.addEventListener("tgtp:section-refreshed", () => attach(section));
    }

    attach(section);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
